import { request } from '@blade/common';
/** ==============================@Description: 通行设备============================== */
/**
*@Description: 分页查询设备列表
*@Date: 2020-09-01 14:39:57
*/
export const getDevicesList = (data) => request({
    url: '/api/iot-device-management/api/v2/iot/devices/list',
    method: 'POST',
    data,
});
// 获取设备属性列表
export const getDevicesTree = (data) => request({
    url: '/api/iot-device-management/api/v2/iot/devices/tree',
    method: 'POST',
    data,
});
/**
*@Description: 通过设备名-设备ID-设备组完全匹配查询当前租户下所有的设备组树形列表
*@Date: 2020-09-01 14:39:57
*/
export const getDevicegroupsTree = (data) => request({
    url: '/api/iot-device-management/api/v2/iot/devicegroups/tree',
    method: 'POST',
    data,
});
/**
*@Description: 查询设备类型
*@Date: 2020-09-01 14:39:57
*/
export const getDevicesTypes = () => request({
    url: '/api/iot-device-management/api/v2/iot/devices/types',
    method: 'GET',
    params: {},
});
export const disableDevice = (id) => request({
    url: `/api/iot-device-management/api/v2/iot/devices/${id}/disable`,
    method: 'POST',
    params: {},
});
export const enableDevice = (id) => request({
    url: `/api/iot-device-management/api/v2/iot/devices/${id}/enable`,
    method: 'POST',
    params: {},
});
/**
*@Description: 删除设备
*@Date: 2020-09-01 14:39:57
*/
export const deleteDevices = (deviceId) => request({
    url: '/api/iot-device-management/api/v2/iot/devices/' + deviceId,
    method: 'DELETE',
});
/**
*@Description: 检查设备能否被删除
*@Date: 2020-09-01 14:39:57
*/
export const devicesCheckDelete = (deviceId) => request({
    url: '/api/iot-device-management/api/v2/iot/devices/checkDelete/' + deviceId,
    method: 'POST',
    // data,
});
/**
*@Description: 查询设备概览
*@Date: 2020-09-01 14:39:57
*/
export const getDevicesSummary = () => request({
    url: '/api/iot-device-management/api/v2/iot/devices/summary',
    method: 'GET',
});
/**
*@Description: 查询设备详情
*@Date: 2020-09-01 14:39:57
*/
export const getDeviceDetail = (deviceId) => request({
    url: '/api/iot-device-management/api/v2/iot/devices/' + deviceId,
    method: 'GET',
    params: {},
});
/**
*@Description: 修改设备
*@Date: 2020-09-01 14:39:57
*/
export const putDeviceDetail = (deviceId, data) => request({
    url: '/api/iot-device-management/api/v2/iot/devices/' + deviceId,
    method: 'PUT',
    // params: {},
    data,
});
export const creatTreeGroup = (data) => request({
    url: '/api/iot-device-management/api/v2/iot/devicegroups',
    method: 'POST',
    data,
});
export const updateTreeGroup = (groupId, data) => request({
    url: `/api/iot-device-management/api/v2/iot/devicegroups/${groupId}`,
    method: 'PUT',
    data,
});
export const deleteTreeGroup = (groupId) => request({
    url: `/api/iot-device-management/api/v2/iot/devicegroups/${groupId}`,
    method: 'DELETE',
});
export const deviceSwitch = (data) => request({
    url: '/api/iot-device-management/api/v2/iot/devices/sub/operate',
    method: 'POST',
    data,
});
export const getPassConfig = (deviceId) => request({
    url: `/api/iot-device-management/api/v2/iot/devices/passconfig/${deviceId}`,
    method: 'GET',
});
export const updatePassConfig = (deviceId, data) => request({
    url: `/api/iot-device-management/api/v2/iot/devices/passconfig/${deviceId}`,
    method: 'POST',
    data
});
export const repostPortrait = (portraitId) => request({
    url: `/api/portrait-management/api/v1/pass/portrait/again/${portraitId}`,
    method: 'POST',
});
export const getPortraitInfo = (id) => request.get(`/api/portrait-management/api/v1/pass/portrait/${id}`);
export const getBackground = () => request({
    url: `/api/iot-device-management/api/v2/iot/devices/backgroundImage`,
    method: 'GET',
});
export const updateBackground = (data) => request({
    url: `/api/iot-device-management/api/v2/iot/devices/backgroundImage`,
    method: 'POST',
    data,
});
// 策略详情
export const ruleDetails = (data) => request({
    url: '/api/access-management/api/v1/pass/rule/details',
    method: 'GET',
    params: data,
});
// 新增策略
export const putRuleDeploy = (data) => request({
    url: '/api/access-management/api/v1/pass/rule/deploy',
    method: 'POST',
    data,
});
// 上传logo和屏幕封面图
export const uploadLogoIdleImgApi = (data) => request.post('/api/iot-device-management/api/v2/iot/devices/image/upload', data);
